module.exports = __webpack_public_path__ + "static/media/9_I wish you enough_SE.55d8b200.txt";